export const strings = {
  networkOffline: {
    title: 'Internet Connection Lost',
    message:
      "Your computer seems to be offline. We'll keep trying to reconnect.",
  },
  networkCriticalLatency: {
    title: 'Network Connection Issue',
    message:
      "We're experiencing connectivity issues. Please check your network connection.",
  },
} as const;
